import { useEffect } from 'react';

import { useSystemDarkTheme } from './useSystemDarkTheme';

export const useDarkModeClass = (
  forceTheme?: 'light' | 'dark',
): 'light' | 'dark' => {
  const isSystemDark = useSystemDarkTheme();

  const mode = forceTheme ?? (isSystemDark ? 'dark' : 'light');

  useEffect(() => {
    const html = document.documentElement;

    if (mode === 'dark') {
      html.classList.add('dark');
    } else {
      html.classList.remove('dark');
    }

    return () => {
      html.classList.remove('dark');
    };
  }, [mode]);

  return mode;
};
